import { render, staticRenderFns } from "./JoszakiSwitch.vue?vue&type=template&id=7c51f77f"
import script from "./JoszakiSwitch.vue?vue&type=script&lang=js"
export * from "./JoszakiSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports